var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',[_c('tr',[_c('td',{staticClass:"label"},[_vm._v("위도")]),_c('td',[_vm._v(_vm._s(_vm.latitude))]),_c('td',{staticClass:"label"},[_vm._v("경도")]),_c('td',[_vm._v(_vm._s(_vm.longitude))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }